import { useMemo as useReactMemo } from 'react'

export const useMemo = useReactMemo

export default useMemo
